import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiheaderService } from './apiheader.service';
import { URLPaths } from '../utilities/urlPaths.config';

@Injectable({
  providedIn: 'root'
})
export class PlanEntryService {

  constructor(private _http: HttpClient) { }

  getPlanEntries(params: any): Observable<any[]> {
    return this._http.get<any[]>(URLPaths.URL_PLAN_ENTRY, {
      params,
      headers: ApiheaderService.getHeaders()
    });
  }

  getCurrentPlanVersion(): Observable<{ plan_version_id: number }> {
    return this._http.get<{ plan_version_id: number }>(
      URLPaths.URL_CURRENT_PLAN_VERSION,
      {
        headers: ApiheaderService.getHeaders()
      }
    );
  }

  updatePlanEntry(id: number, payload: any): Observable<any> {
    return this._http.put(`${URLPaths.URL_PLAN_ENTRY}${id}/`, payload, {
      headers: ApiheaderService.getHeaders()
    });
  }

  deletePlanEntry(id: number, isClash: boolean = false): Observable<any> {
    return this._http.delete(`${URLPaths.URL_PLAN_ENTRY}${id}/`, {
      params: { IsClash: isClash ? '1' : '0' },
      headers: ApiheaderService.getHeaders()
    });
  }

  getConsultantCompany(consultant: string): Observable<any> {
    return this._http.get<any>(
      URLPaths.URL_CONSULTANT_COMPANY,
      {
        params: { consultant },
        headers: ApiheaderService.getHeaders()
      }
    );
  }

getPlanEntryTotal(params: {
  client?: string;
  project?: string;
  dateFrom: string;
  dateTo: string;
  consultant?: string;
  charge?: string;
  clash?: string;
  plan_version_id: string;
}): Observable<{ TotalHours: number | null }> {
  return this._http.get<{ TotalHours: number | null }>(
    URLPaths.URL_PLAN_ENTRY_TOTAL,
    {
      params,
      headers: ApiheaderService.getHeaders()
    }
  );
}
}
